import { getSummarizeOutputValue } from "../features/TextSuite/Components/TextSuitesBody";
import { VideoSuiteApps, WorkflowAppInputAndOutputTypes, WorkflowAppType } from "../Helper";
import { ImageSuiteApps, TextSuiteApps } from "../Helper";
import { WorkflowImageAppSettings } from "../store/one-query/workflowsSlice";

export const getAppDetails = (item: any,WorkflowImageAppSetting?:WorkflowImageAppSettings) => {
  const modelVersion=WorkflowImageAppSetting?.imageModels?.find(model=>model.modelName===item?.selectedFromDropdownItem)?.modelVersion
  const appSettings: { [key: string]: (item: any) => string } = {
    Translator: (item) =>
      item?.selectedFromDropdownItem && item?.selectedToDropdownItem
        ? JSON.stringify({
            sourceLanguage: item.selectedFromDropdownItem,
            targetLanguage: item.selectedToDropdownItem,
          })
        : item?.data
        ? JSON.stringify(item?.data)
        : item?.payload,

    Humanizer: (item) =>
      item?.selectedFromDropdownItem
        ? JSON.stringify({ style: item.selectedFromDropdownItem })
        : item?.data
        ? JSON.stringify(item?.data)
        : item?.payload,

    Summarizer: (item) =>
      item?.selectedFromDropdownItem
        ? JSON.stringify({
            mode: item?.selectedFromDropdownItem,
            textLength: getSummarizeOutputValue(item?.sliderValue),
          })
        : item?.data
        ? JSON.stringify(item?.data)
        : item?.payload,

    Paraphraser: (item) =>
      item?.selectedFromDropdownItem
        ? JSON.stringify({ mode: item?.selectedFromDropdownItem })
        : item?.data
        ? JSON.stringify(item?.data)
        : item?.payload,

    "Text to Image": (item) =>
      item?.selectedFromDropdownItem && item?.selectedToDropdownItem
        ? JSON.stringify({
            modelName: modelVersion,
            imageRatio: item?.selectedToDropdownItem,
          })
        : item?.data
        ? JSON.stringify(item?.data)
        : item?.payload,

    "Logo Generator": (item) =>
      item?.selectedFromDropdownItem && item?.selectedToDropdownItem
        ? JSON.stringify({
            modelName: modelVersion,
            imageRatio: item?.selectedToDropdownItem,
          })
        : item?.data
        ? JSON.stringify(item?.data)
        : item?.payload,

    "Icon Generator": (item) =>
      item?.selectedFromDropdownItem && item?.selectedToDropdownItem
        ? JSON.stringify({
            modelName: modelVersion,
            imageRatio: item?.selectedToDropdownItem,
          })
        : item?.data
        ? JSON.stringify(item?.data)
        : item?.payload,

    "Illustration Generator": (item) =>
      item?.selectedFromDropdownItem && item?.selectedToDropdownItem
        ? JSON.stringify({
            modelName: modelVersion,
            imageRatio: item?.selectedToDropdownItem,
          })
        : item?.data
        ? JSON.stringify(item?.data)
        : item?.payload,

    "Text to Video": (item) =>
      item?.videoSettings?.selectedModel?.version
        ? JSON.stringify({
            model: item?.videoSettings?.selectedModel?.name,
            version: item?.videoSettings?.selectedModel?.version,
            duration: item?.videoSettings?.selectedDuration,
            ratio: item?.videoSettings?.selectedSize,
            resolution: item?.videoSettings?.selectedMode,
            style: item?.videoSettings?.selectedStyle?.value,
            styleName: item?.videoSettings?.selectedStyle?.description,
          })
        : item?.data
        ? JSON.stringify(item?.data)
        : item?.payload,

    "Image to Video": (item) => {
      if (item?.videoSettings?.selectedModel?.version) {
        const baseData: any = {
          model: item?.videoSettings?.selectedModel?.name,
          version: item?.videoSettings?.selectedModel?.version,
          duration: item?.videoSettings?.selectedDuration,
          ratio: item?.videoSettings?.selectedSize,
          resolution: item?.videoSettings?.selectedMode,
          style: item?.videoSettings?.selectedStyle?.value,
          styleName: item?.videoSettings?.selectedStyle?.description,
        };

        if (item?.userInputText &&item?.suiteType===WorkflowAppType.VideoSuite) {
          baseData.userInputText = item?.userInputText;
        }
        if (item?.userInput && item?.suiteType === WorkflowAppType.VideoSuite && typeof item.userInput === "string") {
          baseData.userInput = item?.userInput;
        }

        return JSON.stringify(baseData);
      } else if (item?.data) {
        return JSON.stringify(item.data);
      } else {
        return item?.payload;
      }
    },
  };
  const appObj = appSettings[item?.appType]?.(item);
  return appObj ? appObj : "{}";
};


export  const GetAppType=(appName:string)=>{
    if (Object.values(TextSuiteApps).includes(appName)) {
      return "Text";
    } else if (Object.values(ImageSuiteApps).includes(appName)) {
      return "Image";
    } else if (Object.values(VideoSuiteApps).includes(appName)) {
      return "Video";
    }
}
  
export const WorkflowSharedView = "workflow-share-view";
export const imageToVideoInputType = "Text, Image"
export interface imageToVideoInputInterface {
  InputText: string,
  InputImage: string
}